import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './project-report.types';

export const projectReportSelectors = {
  ...generateResourceSelectors<types.IProjectReport>((state) => state.resource.projectReport),
};
